<template>
  <div>
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <div class="d-flex justify-content-between">
          <div class="my-1">
            <b-form-group class="mb-0 d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <label class="mr-2 mb-0">Per Page</label>
                <b-form-select
                  id="perPageSelect"
                  v-model="perPage"
                  size="sm"
                  :options="perPageOptions"
                  class="w-auto"
                />
                <label class="mb-0">&nbsp;Total {{ dataMeta.of }} entries</label>
              </div>
            </b-form-group>
          </div>
          <div class="my-1"></div>
        </div>

        <b-table
          ref="refInvoiceListTable"
          sticky-header="500px"
          :select-mode="selectMode"
          class="position-relative"
          :items="paymentList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- SL Number (index) -->
          <template #cell(sl)="data">
            <span>{{ currentPage * perPage - perPage + data.index + 1 }}</span>
          </template>

          <!-- Transaction ID -->
          <template #cell(tnx_id)="data">
            {{ data.item.tnx_id }}
          </template>

          <!-- Client ID -->
          <template #cell(create_date)="data">
            {{ data.item.create_date }}
          </template>

          <!-- Payment Date -->
          <template #cell(ref)="data">
            {{ data.item.ref }}
          </template>

          <!-- Deposit Date -->
          <template #cell(credit)="data">
            {{ data.item.credit | formatBDTNumber }}
          </template>

          <!-- Particular -->
          <template #cell(debit)="data">
            {{ data.item.debit | formatBDTNumber }}
          </template>

          <!-- PGW Txn ID -->
          <template #cell(payment_mode)="data">
            {{ data.item.payment_mode }}
          </template>

          <!-- Amount -->
          <template #cell(received_by_name)="data">
            {{ data.item.received_by_name }}
          </template>

          <template #cell(action)="data">
            <b-button
              v-if="getDownloadType(data.item)"
              variant="primary"
              size="sm"
              @click="
                downloadPDF(
                  getDownloadType(data.item).type,
                  getDownloadType(data.item).id
                )
              "
            >
              {{ toCamelCase(getDownloadType(data.item).type) }}
            </b-button>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
                {{ dataMeta.of }} entries</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalInvoiceRecords"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormCheckbox,
  BFormSelect,
  BFormGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { onMounted } from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import usePaymentHistoryList from "../store/usePaymentHistoryList";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    BFormSelect,
    flatPickr,
    vSelect,
    BFormGroup,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      general_config: {
        wrap: true,
        altFormat: "d/m/Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      filter: {
        fromDate: null,
        toDate: null,
        searchQuery: null,
      },

      selectMode: "multi",
      selected: [],
    };
  },
  setup() {
    const {
      sortedInvoiceData,
      loadInvoiceData,
      loadPaymentData,
      paymentList,
      tableColumns,
      perPage,
      currentPage,
      totalInvoiceRecords,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,
      refetchData,
      getDownloadType,
      downloadPDF,
      // UI
      setFilter,
      // Filters
    } = usePaymentHistoryList();

    onMounted(() => {
      loadInvoiceData();
      loadPaymentData();
    });

    return {
      sortedInvoiceData,
      paymentList,
      tableColumns,
      perPage,
      currentPage,
      totalInvoiceRecords,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,
      refetchData,
      getDownloadType,
      downloadPDF,
      // UI
      setFilter,
      // Table
      selected: [],
      selectMode: "multi",
    };
  },
  methods: {
    async fetchFilterData() {
      try {
        const activeFilter = {
          start_date: this.filter.fromDate,
          end_date: this.filter.toDate,
          searchString: this.filter.searchQuery,
        };

        this.setFilter(activeFilter);
        await this.refetchData();
      } catch (error) {
        this.$toast.error("Failed to fetch data. Please try again.");
        console.error("Error:", error);
      }
    },

    toCamelCase(str) {
      return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
    },

    resetFilter() {
      this.filter = {
        fromDate: null,
        toDate: null,
        searchQuery: null,
      };
      this.fetchFilterData();
    },
  },
  created() {
    var _this = this;
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
